import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import "./assets/scss/style.scss";
import HomeOne from "./HomeOne";
import About from "./pages/About";
import Services from "./service/Services";
import EarlyIntervention from "./service/EarlyIntervention";
import PlayLanguageTherapy from "./service/PlayLanguageTherapy";
import SocialCommunication from "./service/SocialCommunication";
import SpeechTherapy from "./service/SpeechTherapy";
import SpecialEducation from "./service/SpecialEducation";
import LearningSupport from "./service/LearningSupport";
import OccupationalTherapy from "./service/OccupationalTherapy";
import ParentCounselling from "./service/ParentCounselling";
import HolisticChildDevelopment from "./service/HolisticChildDevelopment";
import SportsProgramDevelopment from "./service/SportsProgramDevelopment";
import Contact from "./pages/Contact";
import DonateNow from "./project/DonateNow";
import PageNotFound from "./pages/404";
import NoMAtch from "./pages/404";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import FloatingButtons from "./service/components/FloatingButtons";

class Root extends Component {
  render() {
    return (
      <BrowserRouter basename={"/"}>
        <Switch>
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/`}
            component={HomeOne}
          />

          <Route
            exact
            path={`${process.env.PUBLIC_URL}/about-us`}
            component={About}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/services`}
            component={Services}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/early-intervention`}
            component={EarlyIntervention}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/play-language-therapy`}
            component={PlayLanguageTherapy}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/social-communication`}
            component={SocialCommunication}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/speech-therapy`}
            component={SpeechTherapy}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/special-education`}
            component={SpecialEducation}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/learning-support`}
            component={LearningSupport}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/occupational-therapy`}
            component={OccupationalTherapy}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/parent-counselling`}
            component={ParentCounselling}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/holistic-child-development`}
            component={HolisticChildDevelopment}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/sports-program-development`}
            component={SportsProgramDevelopment}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/contact-us`}
            component={Contact}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/donate-now`}
            component={DonateNow}
          />
          <Route
            exact
            path={`${process.env.PUBLIC_URL}/404`}
            component={PageNotFound}
          />
          <Route component={NoMAtch} />

        </Switch>
        {/* Floating Buttons - visible on every page */}
        <FloatingButtons />

      </BrowserRouter>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));

serviceWorker.register();
